import config, { CHAIN_ID, ETHERSCAN_API_KEY, MAINNET_CHAIN_ID } from '../config';

export const getBaseURL = (chainId: number) => {
  // Mainnet = 1, everything else treated as testnet
  if (chainId === MAINNET_CHAIN_ID) {
    return 'https://etherscan.io/';
  }
  return 'https://sepolia.etherscan.io/';
};

const BASE_URL = getBaseURL(CHAIN_ID);

export const buildEtherscanTxLink = (txHash: string): string => {
  const path = `tx/${txHash}`;
  return new URL(path, BASE_URL).toString();
};

export const buildEtherscanAddressLink = (address: string): string => {
  const path = `address/${address}`;
  return new URL(path, BASE_URL).toString();
};

const getApiBaseURL = (chainId: number) => {
  if (chainId === MAINNET_CHAIN_ID) {
    return 'https://api.etherscan.io/';
  }
  return 'https://api-sepolia.etherscan.io/';
};

const API_BASE_URL = getApiBaseURL(CHAIN_ID);

export const getEtherscanContractUrl = () => {
  return `${BASE_URL}address/${config.addresses.bitstraysToken}#readContract`;
}

export const buildEtherscanApiQuery = (
  address: string,
  module = 'contract',
  action = 'getabi',
): string => {
  const params = new URLSearchParams({
    module,
    action,
    address,
    apikey: ETHERSCAN_API_KEY,
  });
  const path = `api?${params.toString()}`;
  return new URL(path, API_BASE_URL).toString();
  
};
